import React, { FC, useState } from 'react';
import { Box, LinearProgress, Pagination } from '@mui/material';
import { useGetCustomersQuery } from '@services';
import SearchBar from './SearchBar';
import { SearchType } from './SearchType';
import { SearchResults } from './SearchResults';

export const CustomerSearch: FC = () => {
  const [searchType, setSearchType] = useState<SearchType>('name');
  const [searchValue, setSearchValue] = useState('');
  const [page, setPage] = useState(1);
  const { data, isFetching } = useGetCustomersQuery({ searchType, searchValue, page });

  const searchTypes = [
    { type: 'phone' as SearchType, regex: /^(04|\+610)\d{2,8}$/ },
    { type: 'email' as SearchType, regex: /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/ },
  ];

  const onSubmit = (searchType: SearchType, searchValue: string) => {
    setPage(1);
    // if search type is name, identify the search value and change the type accordingly
    const filterSearchType = searchTypes.find(({ regex }) => regex.test(searchValue));

    if (filterSearchType !== undefined) setSearchType(filterSearchType.type);
    else setSearchType(searchType);

    setSearchValue(searchValue);
  };

  const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
    setPage(value);
  };

  return (
    <Box data-testid="customer-search">
      <Box py={2}>
        <SearchBar handleSubmit={onSubmit} isLoading={isFetching} />
        {!data && isFetching && <LinearProgress sx={{ my: 1 }} />}
        {data && (
          <>
            <SearchResults customers={data.data} />
            {isFetching && <LinearProgress />}
            <Pagination
              className="pagination-contianer"
              count={data?.meta?.pagination?.total_pages}
              page={page}
              onChange={handleChange}
              variant="outlined"
              shape="rounded"
              data-testid="customer-search-pagination"
              color="primary"
            />
          </>
        )}
      </Box>
    </Box>
  );
};
